import type { Brand } from '../cms/brandConstants';
import { requireBrand } from '../cms/requireBrand';

export type PlaceholderProductType = 'watch' | 'strap' | 'buckle' | 'eyewear' | 'sunglasses';

export type ProductPlaceholderSet = Record<PlaceholderProductType | 'default', string>;

const BREITLING_PLACEHOLDERS: ProductPlaceholderSet = {
  watch: '/images/breitling/placeholders/watch-placeholder.svg',
  strap: '/images/breitling/placeholders/strap-placeholder.svg',
  buckle: '/images/breitling/placeholders/buckle-placeholder.svg',
  eyewear: '/images/breitling/placeholders/generic-placeholder.svg',
  sunglasses: '/images/breitling/placeholders/generic-placeholder.svg',
  default: '/images/breitling/placeholders/generic-placeholder.svg',
};

const GALLET_PLACEHOLDERS: ProductPlaceholderSet = {
  watch: '/images/gallet/placeholders/watch-placeholder.svg',
  strap: '/images/gallet/placeholders/strap-placeholder.svg',
  buckle: '/images/gallet/placeholders/buckle-placeholder.svg',
  eyewear: '/images/gallet/placeholders/generic-placeholder.svg',
  sunglasses: '/images/gallet/placeholders/generic-placeholder.svg',
  default: '/images/gallet/placeholders/generic-placeholder.svg',
};

const UG_PLACEHOLDERS: ProductPlaceholderSet = {
  watch: '/images/ug/placeholders/ug-product-fallback.png',
  strap: '/images/ug/placeholders/ug-product-fallback.png',
  buckle: '/images/ug/placeholders/ug-product-fallback.png',
  eyewear: '/images/ug/placeholders/ug-product-fallback.png',
  sunglasses: '/images/ug/placeholders/ug-product-fallback.png',
  default: '/images/ug/placeholders/ug-product-fallback.png',
};

const PRODUCT_PLACEHOLDERS_BY_BRAND: Record<Brand, ProductPlaceholderSet> = {
  breitling: BREITLING_PLACEHOLDERS,
  gallet: GALLET_PLACEHOLDERS,
  ug: UG_PLACEHOLDERS,
};

export function getActiveBrandProductPlaceholders(
  brand: Brand = requireBrand('application runtime')
): ProductPlaceholderSet {
  return PRODUCT_PLACEHOLDERS_BY_BRAND[brand];
}
